import React, { useState, useEffect, ReactNodeArray } from 'react';
import moment from 'moment';
import { useSelector, useDispatch } from 'react-redux';
import produce, { Draft } from 'immer';
import styled, { css } from 'styled-components';

import { RouteComponentProps, withRouter } from 'react-router-dom';

import MouseEventHeatmap from '../../../components/DataVisualComponents/UXHeatmap/MouseEventHeatmap';
import { RootState } from '../../../modules';
import {
  getPageMouseStaticsAsync,
  getPageElementDataAsync,
  setTargetElementId,
  setTooltipInfo,
  setTooltipInfoMouseFlow,
  uxAnalyticsState,
  GET_PAGE_MOUSE_STATICS,
  GET_EFFECTIVE_CLICK_RATE,
  GET_PAGE_ATTENTION_SCREENS_COUNT,
  GET_PAGE_DURATION,
  getEffectiveClickRateAsync,
  getPageAttentionScreensCountAsync,
  getPageDurationAsync,
} from '../../../modules/PageAnalytics/UXAnalytics';

import { ReactComponent as IconDesktopSVG } from '../../../assets/icons/icon-desktop.svg';

import {
  ContentsLayout,
  ItemGrid,
  ContainerGrid,
} from '../../../components/UIComponents/Layout/DefaultLayout';

import {
  GetPageMouseStaticsParamType,
  GetPageElementDataParamType,
  GetEffectiveClickRateParamType,
  GetPageAttentionScreensCountParamType,
  GetPageDurationParamType,
} from '../../../api/pageAnalytics/uxAnalytics/type';

import PageUsability from '../../../components/DataVisualComponents/Count/PageUsability';
import UXRankCard from '../../../components/DataVisualComponents/Count/UXRankCard';
import MouseFlowTable from '../../../components/DataVisualComponents/Table/MouseFlowTable';
import MouseFlowHeatmap from '../../../components/DataVisualComponents/UXHeatmap/MouseFlowHeatmap';
import MouseScrollHeatmap from '../../../components/DataVisualComponents/UXHeatmap/MouseScrollHeatmap';
import ScrollRankTable from '../../../components/DataVisualComponents/Table/ScrollRankTable';
import { GetPageElementsFlowParamType } from '../../../api/pageAnalytics/uxAnalytics/mouseflow/type';
import {
  getPageElementsFlowAsync,
  setTargetRank,
} from '../../../modules/PageAnalytics/UXAnalytics/MouseFlow';
import { GetScrollEventsParamType } from '../../../api/pageAnalytics/uxAnalytics/scroll/type';
import {
  getScrollEventsAsync,
  GET_SCROLL_EVENTS,
} from '../../../modules/PageAnalytics/UXAnalytics/Scroll';
import Header from '../../../components/Organisms/Header';

interface styledType {
  isActiveType: boolean;
}

const ComponentTabWrapper = styled.div`
  width: 100%;
  height: 36px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const DeviceTypeButtonWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const DeviceTypeButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 158px;
  height: 36px;
  border: none;
  background-color: white;
  cursor: pointer;
  &:first-child {
    border-bottom-left-radius: 8px;
    border-top-left-radius: 8px;
  }
  &:last-child {
    border-bottom-right-radius: 8px;
    border-top-right-radius: 8px;
  }
  color: ${(props) => props.theme.colors.grey500};
  ${(props: styledType) => {
    if (props.isActiveType) {
      return css`
        color: white;
        background-color: #7851e7;
        svg {
          path {
            &:last-child {
              fill: white;
            }
          }
        }
      `;
    }
    return css``;
  }}
`;

const DeviceTypeButtonTitle = styled.div`
  font-family: 'RobotoR', 'NotoKrR';
  font-size: 14px;
  margin-left: 8px;
`;
const DeviceTypeButtonRate = styled.div`
  font-family: 'RobotoR', 'NotoKrR';
  margin-left: 16px;
  font-size: 14px;
`;

const DataTypeButtonWrapper = styled.div`
  display: flex;
`;

const DataTypeButton = styled.button<{ $isActive: boolean }>`
  width: 86px;
  height: 36px;
  font-family: 'RobotoR', 'NotoKrR';
  color: ${(props) => props.theme.colors.grey500};
  background-color: white;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  cursor: pointer;
  &:first-child {
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
  }
  &:last-child {
    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;
  }
  ${(props) => {
    if (props.$isActive) {
      return css`
        background-color: ${props.theme.colors.primary};
        color: white;
      `;
    }
    return css``;
  }}
`;

const testData = [
  {
    x: 0.44266666666666665,
    y: 0.897368022991983,
    width: 0.11466666666666667,
    height: 0.007563152321887763,
    depth: 12,
    element_path:
      'id(root)>>MAIN[1]>>SECTION[5]>>DIV[1]>>DIV[1]>>DIV[1]>>DIV[1]>>DIV[1]>>DIV[3]>>A[1]',
    rate: 10,
    user_cnt: 100,
    cnt: 4,
    duration: 11.11,
    rank: 1,
  },
  {
    x: 0.445,
    y: 0.7830509756466495,
    width: 0.26666666666666666,
    height: 0.015428830736651036,
    depth: 11,
    element_path:
      'id(root)>>MAIN[1]>>SECTION[4]>>DIV[1]>>DIV[2]>>DIV[3]>>FORM[1]>>DIV[4]>>TEXTAREA[1]',
    rate: 10,
    user_cnt: 100,
    cnt: 4,
    duration: 11.11,
    rank: 2,
  },
  {
    x: 0.7973333333333333,
    y: 0.001815156557253063,
    width: 0.08266666666666667,
    height: 0.008470730600514294,
    depth: 9,
    element_path: 'id(root)>>NAV[1]>>DIV[1]>>DIV[3]>>UL[1]>>LI[4]>>A[1]',
    rate: 10,
    user_cnt: 100,
    cnt: 3,
    duration: 8.33,
    rank: 3,
  },
  {
    x: 0.632,
    y: 0.001815156557253063,
    width: 0.08266666666666667,
    height: 0.008470730600514294,
    depth: 9,
    element_path: 'id(root)>>NAV[1]>>DIV[1]>>DIV[3]>>UL[1]>>LI[2]>>A[1]',
    rate: 10,
    user_cnt: 100,
    cnt: 2,
    duration: 5.56,
    rank: 4,
  },
  {
    x: 0.7146666666666667,
    y: 0.001815156557253063,
    width: 0.08266666666666667,
    height: 0.008470730600514294,
    depth: 9,
    element_path: 'id(root)>>NAV[1]>>DIV[1]>>DIV[3]>>UL[1]>>LI[3]>>A[1]',
    rate: 10,
    user_cnt: 100,
    cnt: 2,
    duration: 5.56,
    rank: 5,
  },
  {
    x: 0.445,
    y: 0.7494705793374679,
    width: 0.26666666666666666,
    height: 0.00605052185751021,
    depth: 11,
    element_path:
      'id(root)>>MAIN[1]>>SECTION[4]>>DIV[1]>>DIV[2]>>DIV[3]>>FORM[1]>>DIV[1]>>INPUT[1]',
    rate: 10,
    user_cnt: 100,
    cnt: 2,
    duration: 5.56,
    rank: 6,
  },
  {
    x: 0.5911979166666667,
    y: 0.37413969142338527,
    width: 0.2886666666666667,
    height: 0.008470730600514294,
    depth: 11,
    element_path:
      'id(root)>>MAIN[1]>>DIV[2]>>SECTION[1]>>DIV[1]>>DIV[1]>>DIV[2]>>DIV[1]>>DIV[2]',
    rate: 10,
    user_cnt: 100,
    cnt: 2,
    duration: 5.56,
    rank: 7,
  },
  {
    x: 0.21119791666666668,
    y: 0.43177091211617,
    width: 0.2886666666666667,
    height: 0.004991680532445923,
    depth: 11,
    element_path:
      'id(root)>>MAIN[1]>>DIV[2]>>SECTION[1]>>DIV[1]>>DIV[2]>>DIV[2]>>DIV[1]>>DIV[1]',
    rate: 10,
    user_cnt: 100,
    cnt: 1,
    duration: 2.78,
    rank: 8,
  },
  {
    x: 0.445,
    y: 0.7718575102102556,
    width: 0.26666666666666666,
    height: 0.00605052185751021,
    depth: 11,
    element_path:
      'id(root)>>MAIN[1]>>SECTION[4]>>DIV[1]>>DIV[2]>>DIV[3]>>FORM[1]>>DIV[3]>>INPUT[1]',
    rate: 10,
    user_cnt: 100,
    cnt: 1,
    duration: 2.78,
    rank: 9,
  },
  {
    x: 0.21119791666666668,
    y: 0.4382752231129935,
    width: 0.2886666666666667,
    height: 0.012706095900771442,
    depth: 11,
    element_path:
      'id(root)>>MAIN[1]>>DIV[2]>>SECTION[1]>>DIV[1]>>DIV[2]>>DIV[2]>>DIV[1]>>DIV[2]',
    rate: 10,
    user_cnt: 100,
    cnt: 1,
    duration: 2.78,
    rank: 10,
  },
  {
    x: 0.8159895833333334,
    y: 0.8009000151263046,
    width: 0.064,
    height: 0.004840417486008168,
    depth: 12,
    element_path: 'id(PopoverLegacy)',
    rate: 10,
    user_cnt: 100,
    cnt: 1,
    duration: 2.78,
    rank: 11,
  },
  {
    x: 0.0,
    y: 0.0,
    width: 0.0,
    height: 0.0,
    depth: 12,
    element_path: 'id(PopoverLegacy)',
    rate: 10,
    user_cnt: 100,
    cnt: 1,
    duration: 2.78,
    rank: 12,
  },
  {
    x: 0.5266666666666666,
    y: 0.001815156557253063,
    width: 0.10533333333333333,
    height: 0.008470730600514294,
    depth: 9,
    element_path: 'id(root)>>NAV[1]>>DIV[1]>>DIV[3]>>UL[1]>>LI[1]>>A[1]',
    rate: 10,
    user_cnt: 100,
    cnt: 1,
    duration: 2.78,
    rank: 13,
  },
  {
    x: 0.5911979166666667,
    y: 0.5099739071244895,
    width: 0.2886666666666667,
    height: 0.012706095900771442,
    depth: 11,
    element_path:
      'id(root)>>MAIN[1]>>DIV[2]>>SECTION[1]>>DIV[1]>>DIV[3]>>DIV[2]>>DIV[1]>>DIV[2]',
    rate: 10,
    user_cnt: 100,
    cnt: 1,
    duration: 2.78,
    rank: 14,
  },
  {
    x: 0.21119791666666668,
    y: 0.5783448041143548,
    width: 0.2886666666666667,
    height: 0.008470730600514294,
    depth: 12,
    element_path:
      'id(root)>>MAIN[1]>>DIV[2]>>SECTION[1]>>DIV[1]>>DIV[4]>>DIV[2]>>DIV[1]>>DIV[2]>>H5[1]',
    rate: 10,
    user_cnt: 100,
    cnt: 1,
    duration: 2.78,
    rank: 15,
  },
  {
    x: 0.7813333333333333,
    y: 0.9739071244894872,
    width: 0.024,
    height: 0.006958100136136742,
    depth: 11,
    element_path:
      'id(root)>>MAIN[1]>>SECTION[5]>>FOOTER[1]>>DIV[1]>>DIV[1]>>DIV[1]>>DIV[2]>>A[2]',
    rate: 10,
    user_cnt: 100,
    cnt: 1,
    duration: 2.78,
    rank: 16,
  },
  {
    x: 0.12,
    y: 0.003025260928755105,
    width: 0.07933333333333334,
    height: 0.00605052185751021,
    depth: 7,
    element_path: 'id(root)>>NAV[1]>>DIV[1]>>DIV[1]>>A[1]',
    rate: 10,
    user_cnt: 100,
    cnt: 1,
    duration: 2.78,
    rank: 17,
  },
  {
    x: 0.0,
    y: 0.0,
    width: 1.0,
    height: 0.13311148086522462,
    depth: 6,
    element_path: 'id(root)>>MAIN[1]>>DIV[1]>>HEADER[1]',
    rate: 10,
    user_cnt: 100,
    cnt: 1,
    duration: 2.78,
    rank: 18,
  },
  {
    x: 0.13,
    y: 0.06428679473604598,
    width: 0.74,
    height: 0.007260626229012252,
    depth: 12,
    element_path:
      'id(root)>>MAIN[1]>>DIV[1]>>HEADER[1]>>DIV[1]>>DIV[1]>>DIV[1]>>DIV[1]>>DIV[1]>>H1[1]',
    rate: 10,
    user_cnt: 100,
    cnt: 1,
    duration: 2.78,
    rank: 19,
  },
  {
    x: 0.0,
    y: 0.8286189683860233,
    width: 1.0,
    height: 0.12403569807895931,
    depth: 6,
    element_path: 'id(root)>>MAIN[1]>>SECTION[5]>>DIV[1]',
    rate: 10,
    user_cnt: 100,
    cnt: 1,
    duration: 2.78,
    rank: 20,
  },
];

const scrollDataTemp = {
  height: 2666,
  section_cnt: 27,
  page_duration: 55.29,
  heatmap: [
    {
      rate: 71.23,
    },
    {
      rate: 72.6,
    },
    {
      rate: 73.97,
    },
    {
      rate: 76.71,
    },
    {
      rate: 78.08,
    },
    {
      rate: 78.08,
    },
    {
      rate: 78.08,
    },
    {
      rate: 78.08,
    },
    {
      rate: 79.45,
    },
    {
      rate: 79.45,
    },
    {
      rate: 79.45,
    },
    {
      rate: 79.45,
    },
    {
      rate: 79.45,
    },
    {
      rate: 79.45,
    },
    {
      rate: 79.45,
    },
    {
      rate: 79.45,
    },
    {
      rate: 82.19,
    },
    {
      rate: 82.19,
    },
    {
      rate: 83.56,
    },
    {
      rate: 84.93,
    },
    {
      rate: 90.41,
    },
    {
      rate: 91.78,
    },
    {
      rate: 91.78,
    },
    {
      rate: 91.78,
    },
    {
      rate: 91.78,
    },
    {
      rate: 90.41,
    },
    {
      rate: 90.41,
    },
    {
      rate: 90.41,
    },
    {
      rate: 91.78,
    },
    {
      rate: 91.78,
    },
    {
      rate: 89.04,
    },
    {
      rate: 89.04,
    },
    {
      rate: 89.04,
    },
    {
      rate: 89.04,
    },
    {
      rate: 89.04,
    },
    {
      rate: 87.67,
    },
    {
      rate: 86.3,
    },
    {
      rate: 83.56,
    },
    {
      rate: 83.56,
    },
    {
      rate: 83.56,
    },
    {
      rate: 84.93,
    },
    {
      rate: 71.23,
    },
    {
      rate: 71.23,
    },
    {
      rate: 71.23,
    },
    {
      rate: 71.23,
    },
    {
      rate: 71.23,
    },
    {
      rate: 71.23,
    },
    {
      rate: 71.23,
    },
    {
      rate: 71.23,
    },
    {
      rate: 67.12,
    },
    {
      rate: 67.12,
    },
    {
      rate: 67.12,
    },
    {
      rate: 67.12,
    },
    {
      rate: 67.12,
    },
    {
      rate: 67.12,
    },
    {
      rate: 67.12,
    },
    {
      rate: 65.75,
    },
    {
      rate: 64.38,
    },
    {
      rate: 64.38,
    },
    {
      rate: 63.01,
    },
    {
      rate: 63.01,
    },
    {
      rate: 64.38,
    },
    {
      rate: 64.38,
    },
    {
      rate: 63.01,
    },
    {
      rate: 61.64,
    },
    {
      rate: 61.64,
    },
    {
      rate: 60.27,
    },
    {
      rate: 58.9,
    },
    {
      rate: 58.9,
    },
    {
      rate: 58.9,
    },
    {
      rate: 58.9,
    },
    {
      rate: 57.53,
    },
    {
      rate: 56.16,
    },
    {
      rate: 53.42,
    },
    {
      rate: 53.42,
    },
    {
      rate: 52.05,
    },
    {
      rate: 52.05,
    },
    {
      rate: 52.05,
    },
    {
      rate: 52.05,
    },
    {
      rate: 52.05,
    },
    {
      rate: 50.68,
    },
    {
      rate: 50.68,
    },
    {
      rate: 50.68,
    },
    {
      rate: 50.68,
    },
    {
      rate: 50.68,
    },
    {
      rate: 50.68,
    },
    {
      rate: 50.68,
    },
    {
      rate: 50.68,
    },
    {
      rate: 50.68,
    },
    {
      rate: 50.68,
    },
    {
      rate: 50.68,
    },
    {
      rate: 50.68,
    },
    {
      rate: 52.05,
    },
    {
      rate: 52.05,
    },
    {
      rate: 52.05,
    },
    {
      rate: 52.05,
    },
    {
      rate: 52.05,
    },
    {
      rate: 52.05,
    },
    {
      rate: 52.05,
    },
    {
      rate: 52.05,
    },
  ],
  scroll_usability: [
    {
      view_rate: 76.71,
      avg_attention_time: 18.85,
      attention_rate: 8.75,
    },
    {
      view_rate: 78.08,
      avg_attention_time: 18.85,
      attention_rate: 8.75,
    },
    {
      view_rate: 79.45,
      avg_attention_time: 18.85,
      attention_rate: 8.75,
    },
    {
      view_rate: 79.45,
      avg_attention_time: 18.85,
      attention_rate: 8.75,
    },
    {
      view_rate: 84.93,
      avg_attention_time: 11.76,
      attention_rate: 8.02,
    },
    {
      view_rate: 91.78,
      avg_attention_time: 17.37,
      attention_rate: 10.43,
    },
    {
      view_rate: 91.78,
      avg_attention_time: 5.74,
      attention_rate: 2.19,
    },
    {
      view_rate: 94.52,
      avg_attention_time: 3.58,
      attention_rate: 1.57,
    },
    {
      view_rate: 89.04,
      avg_attention_time: 11.46,
      attention_rate: 6.57,
    },
    {
      view_rate: 86.3,
      avg_attention_time: 4.44,
      attention_rate: 1.82,
    },
    {
      view_rate: 86.3,
      avg_attention_time: 6.87,
      attention_rate: 2.63,
    },
    {
      view_rate: 71.23,
      avg_attention_time: 1.67,
      attention_rate: 0.73,
    },
    {
      view_rate: 71.23,
      avg_attention_time: 5.63,
      attention_rate: 2.61,
    },
    {
      view_rate: 69.86,
      avg_attention_time: 2.35,
      attention_rate: 1.29,
    },
    {
      view_rate: 65.75,
      avg_attention_time: 5.29,
      attention_rate: 2.31,
    },
    {
      view_rate: 64.38,
      avg_attention_time: 1.26,
      attention_rate: 0.45,
    },
    {
      view_rate: 61.64,
      avg_attention_time: 1.49,
      attention_rate: 0.41,
    },
    {
      view_rate: 58.9,
      avg_attention_time: 1.06,
      attention_rate: 0.32,
    },
    {
      view_rate: 56.16,
      avg_attention_time: 3.59,
      attention_rate: 1.57,
    },
    {
      view_rate: 52.05,
      avg_attention_time: 1.81,
      attention_rate: 0.89,
    },
    {
      view_rate: 50.68,
      avg_attention_time: 5.2,
      attention_rate: 2.13,
    },
    {
      view_rate: 50.68,
      avg_attention_time: 2.03,
      attention_rate: 0.94,
    },
    {
      view_rate: 50.68,
      avg_attention_time: 8.57,
      attention_rate: 3.04,
    },
    {
      view_rate: 52.05,
      avg_attention_time: 1.3,
      attention_rate: 0.46,
    },
    {
      view_rate: 52.05,
      avg_attention_time: 37.43,
      attention_rate: 40.87,
    },
    {
      view_rate: 52.05,
      avg_attention_time: 1.3,
      attention_rate: 0.46,
    },
    {
      view_rate: 52.05,
      avg_attention_time: 37.43,
      attention_rate: 40.87,
    },
  ],
  attention_section: [
    {
      index: 0,
      avg_attention_time: 6.08,
      attention_rate: 0.02,
    },
    {
      index: 1,
      avg_attention_time: 2.53,
      attention_rate: 0.02,
    },
    {
      index: 25,
      avg_attention_time: 1.24,
      attention_rate: 0.0,
    },
    {
      index: 21,
      avg_attention_time: 1.12,
      attention_rate: 0.0,
    },
    {
      index: 26,
      avg_attention_time: 1.0,
      attention_rate: 0.0,
    },
  ],
};

interface UXAnalysisProps extends RouteComponentProps {}

const UXAnalysis = ({ location }: UXAnalysisProps) => {
  // redux
  const { scrollEventsData } = useSelector((state: RootState) => state.scroll);
  const { mouseflowData, targetRank } = useSelector(
    (state: RootState) => state.mouseFlow
  );
  const {
    tooltipInfo,
    mouseStaticsData,
    elementData,
    targetElementID,
    tooltipInfoMouseFlow,
    effectiveClickRate,
    pageAttentionScreensCount,
    pageDuration,
  } = useSelector((state: RootState) => state.pageUXAnalytics);
  const { startDate, endDate, isDatePickerToggle } = useSelector(
    (state: RootState) => state.datePicker
  );
  const loading = useSelector((state: RootState) => state.loading);
  const dispatch = useDispatch();

  const onSetTargetRank = (target_rank: number) => {
    dispatch(setTargetRank(target_rank));
  };

  const onGetScrollEvents = (info: GetScrollEventsParamType) => {
    dispatch(getScrollEventsAsync.request(info));
  };

  const onGetEffectiveClickRate = (info: GetEffectiveClickRateParamType) => {
    dispatch(getEffectiveClickRateAsync.request(info));
  };

  const onGetPageAttentionScreensCount = (
    info: GetPageAttentionScreensCountParamType
  ) => {
    dispatch(getPageAttentionScreensCountAsync.request(info));
  };

  const onGetPageDuration = (info: GetPageDurationParamType) => {
    dispatch(getPageDurationAsync.request(info));
  };

  const onGetPageClickStatics = (info: GetPageMouseStaticsParamType) => {
    dispatch(getPageMouseStaticsAsync.request(info));
  };

  const onGetPageElementData = (info: GetPageElementDataParamType) => {
    dispatch(getPageElementDataAsync.request(info));
  };

  const onSetTargetElementId = (targetElementId: string) => {
    dispatch(setTargetElementId(targetElementId));
  };

  const onSetTooltipInfo = (info: uxAnalyticsState['tooltipInfo']) => {
    dispatch(setTooltipInfo(info));
  };

  const onSetTooltipInfoMouseFlow = (
    info: uxAnalyticsState['tooltipInfoMouseFlow']
  ) => {
    dispatch(setTooltipInfoMouseFlow(info));
  };

  const onGetPageElementsFlow = (info: GetPageElementsFlowParamType) => {
    dispatch(getPageElementsFlowAsync.request(info));
  };

  // state
  const [pageId, setPageId] = useState('');
  const [isActiveDataType, setIsActiveDataType] = useState({
    click: true,
    move: false,
    mouseflow: false,
    scroll: false,
  });

  useEffect(() => {
    onSetTargetElementId('');
    const params: { [key: string]: string } = {};
    location.search.replace(
      /[?&]+([^=&]+)=([^&]*)/gi,
      (str: string, key: string, value: string) => {
        params[key] = value;
        return value;
      }
    );

    setPageId(params.pageid);
  }, []);

  useEffect(() => {
    if (!isDatePickerToggle && pageId !== '') {
      onGetEffectiveClickRate({
        start_date: moment(startDate).format('YYYY-MM-DD'),
        end_date: moment(endDate).format('YYYY-MM-DD'),
        page_id: pageId,
      });
      onGetPageAttentionScreensCount({
        start_date: moment(startDate).format('YYYY-MM-DD'),
        end_date: moment(endDate).format('YYYY-MM-DD'),
        page_id: pageId,
      });
      onGetPageDuration({
        start_date: moment(startDate).format('YYYY-MM-DD'),
        end_date: moment(endDate).format('YYYY-MM-DD'),
        page_id: pageId,
      });
      onSetTargetElementId('');
    }
  }, [isDatePickerToggle, startDate, endDate, pageId]);

  useEffect(() => {
    if (!isDatePickerToggle && pageId !== '') {
      if (isActiveDataType.click) {
        onGetPageElementData({
          start_date: moment(startDate).format('YYYY-MM-DD'),
          end_date: moment(endDate).format('YYYY-MM-DD'),
          page_id: pageId,
          event_status: 'click',
        });
        onGetPageClickStatics({
          start_date: moment(startDate).format('YYYY-MM-DD'),
          end_date: moment(endDate).format('YYYY-MM-DD'),
          page_id: pageId,
          event_status: 'click',
        });
      } else if (isActiveDataType.move) {
        onGetPageElementData({
          start_date: moment(startDate).format('YYYY-MM-DD'),
          end_date: moment(endDate).format('YYYY-MM-DD'),
          page_id: pageId,
          event_status: 'move',
        });
        onGetPageClickStatics({
          start_date: moment(startDate).format('YYYY-MM-DD'),
          end_date: moment(endDate).format('YYYY-MM-DD'),
          page_id: pageId,
          event_status: 'move',
        });
      } else if (isActiveDataType.mouseflow) {
        onGetPageElementsFlow({
          start_date: moment(startDate).format('YYYY-MM-DD'),
          end_date: moment(endDate).format('YYYY-MM-DD'),
          page_id: pageId,
        });
      } else if (isActiveDataType.scroll) {
        onGetScrollEvents({
          start_date: moment(startDate).format('YYYY-MM-DD'),
          end_date: moment(endDate).format('YYYY-MM-DD'),
          page_id: pageId,
        });
      }
      onSetTargetElementId('');
    }
  }, [isDatePickerToggle, startDate, endDate, pageId, isActiveDataType]);

  const onClickDataTypeButton = (id: string) => {
    onSetTargetElementId('');
    setIsActiveDataType(
      produce((draft: Draft<typeof isActiveDataType>) => {
        return {
          click: false,
          move: false,
          mouseflow: false,
          scroll: false,
          [id]: true,
        };
      })
    );
  };

  const printHeatmap = () => {
    const result: ReactNodeArray = [];
    if (isActiveDataType.click) {
      result.push(
        <MouseEventHeatmap
          key={0}
          pageEventStaticsData={mouseStaticsData}
          pageElementData={elementData}
          targetElementID={targetElementID}
          pageId={pageId}
          tooltipInfo={tooltipInfo}
          isActiveDataType={isActiveDataType}
          onSetTargetElementId={onSetTargetElementId}
          onSetTooltipInfo={onSetTooltipInfo}
        />
      );
    } else if (isActiveDataType.move) {
      result.push(
        <MouseEventHeatmap
          key={1}
          pageEventStaticsData={mouseStaticsData}
          pageElementData={elementData}
          targetElementID={targetElementID}
          pageId={pageId}
          tooltipInfo={tooltipInfo}
          isActiveDataType={isActiveDataType}
          onSetTargetElementId={onSetTargetElementId}
          onSetTooltipInfo={onSetTooltipInfo}
        />
      );
    } else if (isActiveDataType.mouseflow) {
      result.push(
        <MouseFlowHeatmap
          key={2}
          pageElementData={mouseflowData}
          targetRank={targetRank}
          pageId={pageId}
          tooltipInfoMouseFlow={tooltipInfoMouseFlow}
          onSetTargetRank={onSetTargetRank}
          onSetTooltipInfoMouseFlow={onSetTooltipInfoMouseFlow}
        />
      );
    } else if (isActiveDataType.scroll) {
      result.push(
        <MouseScrollHeatmap key={3} data={scrollEventsData} pageId={pageId} />
      );
    }
    return result;
  };
  const printRankCard = () => {
    const result: ReactNodeArray = [];
    if (isActiveDataType.click) {
      result.push(
        <UXRankCard
          key={0}
          elementData={elementData}
          targetElementID={targetElementID}
          pageId={pageId}
          isActiveDataType={isActiveDataType}
          isLoading={loading[GET_PAGE_MOUSE_STATICS] || false}
          onSetTargetElementId={onSetTargetElementId}
          onSetTooltipInfo={onSetTooltipInfo}
        />
      );
    } else if (isActiveDataType.move) {
      result.push(
        <UXRankCard
          key={1}
          elementData={elementData}
          targetElementID={targetElementID}
          pageId={pageId}
          isActiveDataType={isActiveDataType}
          isLoading={loading[GET_PAGE_MOUSE_STATICS] || false}
          onSetTargetElementId={onSetTargetElementId}
          onSetTooltipInfo={onSetTooltipInfo}
        />
      );
    } else if (isActiveDataType.mouseflow) {
      result.push(
        <MouseFlowTable
          key={2}
          pageElementData={mouseflowData}
          targetRank={targetRank}
          pageId={pageId}
          onSetTargetRank={onSetTargetRank}
          onSetTooltipInfoMouseFlow={onSetTooltipInfoMouseFlow}
        />
      );
    } else if (isActiveDataType.scroll) {
      result.push(
        <ScrollRankTable
          key={3}
          data={scrollEventsData}
          pageId={pageId}
          isLoading={loading[GET_SCROLL_EVENTS] || false}
        />
      );
    }
    return result;
  };

  return (
    <ContentsLayout>
      <Header title="UX 분석" isDatePicker />
      <ContainerGrid $spacing="xsm">
        <ItemGrid $desktop={12}>
          <ComponentTabWrapper>
            <DataTypeButtonWrapper>
              <DataTypeButton
                $isActive={isActiveDataType.click}
                onClick={() => {
                  onClickDataTypeButton('click');
                }}
              >
                Click
              </DataTypeButton>
              <DataTypeButton
                $isActive={isActiveDataType.move}
                onClick={() => {
                  onClickDataTypeButton('move');
                }}
              >
                Move
              </DataTypeButton>
              <DataTypeButton
                $isActive={isActiveDataType.mouseflow}
                onClick={() => {
                  onClickDataTypeButton('mouseflow');
                }}
              >
                Mouseflow
              </DataTypeButton>
              <DataTypeButton
                $isActive={isActiveDataType.scroll}
                onClick={() => {
                  onClickDataTypeButton('scroll');
                }}
              >
                Scroll
              </DataTypeButton>
            </DataTypeButtonWrapper>
            {/* <DeviceTypeButtonWrapper>
              <DeviceTypeButton isActiveType>
                <IconDesktopSVG width="18px" />
                <DeviceTypeButtonTitle>데스크톱</DeviceTypeButtonTitle>
                <DeviceTypeButtonRate>00.00%</DeviceTypeButtonRate>
              </DeviceTypeButton>
              <DeviceTypeButton isActiveType={false}>
                <IconTabletSVG width="18px" />
                <DeviceTypeTitle>태블릿</DeviceTypeTitle>
                <DeviceTypeRate>00.00%</DeviceTypeRate>
              </DeviceTypeButton>
              <DeviceTypeButton isActiveType={false}>
                <IconPhoneSVG width="18px" />
                <DeviceTypeTitle>모바일</DeviceTypeTitle>
                <DeviceTypeRate>00.00%</DeviceTypeRate>
              </DeviceTypeButton>
            </DeviceTypeButtonWrapper> */}
          </ComponentTabWrapper>
        </ItemGrid>

        <ItemGrid $desktop={6}>
          {pageId !== '' ? printHeatmap() : null}
        </ItemGrid>
        <ItemGrid $desktop={6}>
          <ContainerGrid $spacing="xsm">
            <ItemGrid $desktop={12}>
              <PageUsability
                loading={
                  loading[GET_EFFECTIVE_CLICK_RATE] ||
                  loading[GET_PAGE_ATTENTION_SCREENS_COUNT] ||
                  loading[GET_PAGE_DURATION] ||
                  false
                }
                pageUsabilityData={{
                  effectiveClickRate,
                  pageAttentionScreensCount,
                  pageDuration,
                }}
              />
            </ItemGrid>
            <ItemGrid $desktop={12}>{printRankCard()}</ItemGrid>
          </ContainerGrid>
        </ItemGrid>
      </ContainerGrid>
    </ContentsLayout>
  );
};

export default withRouter(UXAnalysis);
